import {Button, Dropdown} from 'antd'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default function PropertiesPaneButtonExportReq(props) {
    const map = useMapContext()

    const {
        exportReq,
        exportReq3,
        exportReq4,
        exportReqAll,
        exportReqAll2,
    } = map.commands

    const items = [
        {
            label: (
                <div onClick={() => exportReq({expBizFlag: '0'})}>
                    软件需求1
                </div>
            ),
        },

        {
            label: (
                <div onClick={() => exportReqAll({expBizFlag: '0'})}>
                    软件需求1-1汇总
                </div>
            ),
        },

        {
            label: (
                <div onClick={() => exportReqAll2()}>
                    软件需求1-2汇总
                </div>
            ),
        },

        {
            label: (
                <div onClick={() => exportReq({expBizFlag: '0', includeBdLogicFlag: '1'})}>
                    软件需求2
                </div>
            ),

            title: '含处理逻辑',
        },

        {
            label: (
                <div onClick={() => exportReq3()}>
                    软件需求3
                </div>
            ),
        },

        {
            label: (
                <div onClick={() => exportReq4()}>
                    软件需求4
                </div>
            ),
        },

        {
            label: (
                <div onClick={() => exportReq({expBizFlag: '1'})}>
                    业务需求
                </div>
            ),
        },
    ]

    return (
        <Dropdown
            menu={{items}}
            placement="bottomLeft"
            {...props}
        >
            <Button>导出需求文档</Button>
        </Dropdown>
    )
}
